import { SPECIFICATIONS } from '@/constants/product';
import Card from '@/components/Card';
import { classes } from './utils';

export interface SpecificationsCardProps {
  className?: string;
}

export default function SpecificationsCard({
  className,
}: SpecificationsCardProps) {
  return (
    <Card className={className}>
      <div className={classes.header}>SPECIFICATIONS</div>
      <div className={classes.grid}>
        {SPECIFICATIONS.map((spec) => (
          <div key={spec.key} className={classes.row}>
            <span className={classes.key}>{spec.key}</span>
            <span className={classes.value}>{spec.value}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
